(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────── */

  function shopifyImg(url, size) {
    if (!url) return null;
    return url.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + 'x' + size + '$1$2');
  }

  function formatMoney(cents) {
    var curr = 'CHF';
    try { curr = window.Shopify.currency.active || 'CHF'; } catch (e) {}
    try {
      /* Force en-US locale so separator is '.' not ',' (de-CH gives 82,00) */
      var formatted = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
      return curr + ' ' + formatted;
    } catch (e) {
      return curr + ' ' + (cents / 100).toFixed(2);
    }
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Product helpers ─────────────────────────────────────── */

  function bestVariant(product) {
    return product.variants.find(function (v) {
      return v.available && v.price > 0;
    });
  }

  function getVariantSize(variant) {
    var t = (variant.option1 || variant.title || '').trim();
    if (!t || t === 'Default Title') return '';
    /* Einheiten-Anzeige vereinheitlicht (29.07.2026): «50ml» -> «50 ml»,
       gleiche Normalisierung wie Spec-Sheet/INHALT-Zeile. */
    return t.replace(/\s*ml\b/i, '\u00a0ml');
  }

  function filterProducts(products, cartIds) {
    return products.filter(function (p) {
      if (cartIds.indexOf(Number(p.id)) !== -1) return false;
      if (p.product_type === 'Gift Cards') return false;
      if (!bestVariant(p)) return false;
      return true;
    });
  }

  /* ── Card HTML ───────────────────────────────────────────── */

  function buildCard(product, btnLabel, btnClass, imgSize) {
    var variant = bestVariant(product);
    if (!variant) return '';

    var size    = getVariantSize(variant);
    var price   = formatMoney(variant.price);
    // Gestapelte Meta (Redesign 14.08.2026): Groesse und Preis als
    // eigene Zeilen — kein Pipe-/Trenner-Konstrukt (Briefing 0/5).
    var meta = (size ? '<span class="jk-cart-related-card__size">' + esc(size) + '</span>' : '')
      + '<span class="jk-cart-related-card__price">' + esc(price) + '</span>';

    // Freisteller-Map (13.08.2026): serverseitig gerenderte
    // handle->jk_collection_image-URL bevorzugen; Fallback featured.
    var cutout  = (window.__jkCutoutMap || {})[product.handle];
    var imgSrc  = cutout || shopifyImg(product.featured_image, imgSize || 160);
    var imgHtml = imgSrc
      ? '<a href="' + esc(product.url) + '" class="jk-cart-related-card__image-link"'
        + ' tabindex="-1" aria-hidden="true">'
        + '<img class="jk-cart-related-card__image" src="' + esc(imgSrc) + '"'
        + ' alt="' + esc(product.title) + '" width="80" height="100" loading="lazy"></a>'
      : '';

    return '<jk-upsell-button class="jk-cart-related-card"'
      + ' data-variant-id="' + variant.id + '"'
      + ' data-btn-label="' + esc(btnLabel) + '">'
      + '<div class="jk-cart-related-card__row">'
      + imgHtml
      + '<div class="jk-cart-related-card__content">'
      + '<a href="' + esc(product.url) + '" class="jk-cart-related-card__title">'
      + esc(product.title) + '</a>'
      + '<p class="jk-cart-related-card__meta">' + meta + '</p>'
      + '</div></div>'
      + '<button type="button" class="jk-btn ' + btnClass + ' jk-cart-related-card__button">' + esc(btnLabel) + '</button>'
      + '</jk-upsell-button>';
  }

  /* ── Main loader ─────────────────────────────────────────── */

  (function readCutoutMap() {
    var el = document.querySelector('[data-jk-cutout-map]');
    if (!el) return;
    try { window.__jkCutoutMap = JSON.parse(el.textContent); } catch (e) {}
  })();

  async function loadRec(container) {
    if (container._jkLoading) return;
    container._jkLoading = true;

    var anchorIds = (container.dataset.anchors || container.dataset.anchor || '').split(',').filter(Boolean);
    var cartIds   = (container.dataset.cartIds || '').split(',').filter(Boolean).map(Number);
    var btnLabel  = container.dataset.btnLabel || 'Add';
    // Variante B (Wild-Green-Flaeche, Nachtrag 3): auf dunklem Grund
    // traegt der Add-Button den Inverse-Modifier des Systems.
    var btnClass  = container.getAttribute('data-jk-scheme') === 'green' ? 'jk-btn--inverse' : 'jk-btn--secondary';
    /* Cart-Seite rendert grosse 4:5-Karten (Cart v02): Container darf
       eine groessere Bildkante anfordern; Drawer bleibt bei 160. */
    var imgSize   = parseInt(container.dataset.imgSize || '160', 10) || 160;

    if (!anchorIds.length) {
      container._jkLoading = false;
      return;
    }

    try {
      var products = [];

      for (var i = 0; i < anchorIds.length && !products.length; i++) {
        var url = '/recommendations/products.json'
          + '?product_id=' + anchorIds[i]
          + '&limit=8'
          + '&intent=related';

        var resp = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!resp.ok) continue;

        var data = await resp.json();
        products = filterProducts(data.products || [], cartIds);
      }

      var limit = parseInt(container.dataset.limit || '1', 10) || 1;
      products = products.slice(0, limit);

      if (!products.length) {
        container._jkLoading = false;
        return;
      }

      var contentEl = container.querySelector('.jk-cart-related-upsell__content');
      if (!contentEl) {
        console.error('[JK-CartRec] .jk-cart-related-upsell__content not found');
        container._jkLoading = false;
        return;
      }

      contentEl.innerHTML = products.map(function (p) { return buildCard(p, btnLabel, btnClass, imgSize); }).join('');
      container.removeAttribute('hidden');

    } catch (e) {
      console.error('[JK-CartRec] loadRec error:', e);
      container._jkLoading = false;
    }
  }

  /* ── Cart-page rec refresh ───────────────────────────────── */

  async function refreshPageRec() {
    var section = document.querySelector('section.jk-cart-recs.jk-cart-related-upsell');
    if (!section) return;

    try {
      var resp = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!resp.ok) return;
      var cart  = await resp.json();
      var items = cart.items || [];
      var pids  = items.map(function (i) { return i.product_id; });
      var joined = pids.join(',');

      if (!joined) {
        section.setAttribute('hidden', '');
        return;
      }

      section.dataset.anchors  = joined;
      section.dataset.cartIds  = joined;
      section.setAttribute('hidden', '');
      delete section._jkLoading;

      var content = section.querySelector('.jk-cart-related-upsell__content');
      if (content) content.innerHTML = '';

      loadRec(section);
    } catch (_e) {}
  }

  /* ── Init ────────────────────────────────────────────────── */

  function initRecs() {
    document.querySelectorAll('.jk-cart-related-upsell[hidden]').forEach(loadRec);
  }

  initRecs();

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(initRecs).observe(drawer, { childList: true, subtree: true });
  }

  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble) {
    new MutationObserver(initRecs).observe(bubble, { childList: true, subtree: true });
  }

  /* Re-Init nach Cart-Updates auf der Warenkorbseite: cart.js ersetzt
     .js-contents komplett — der In-Spalten-Container (.jk-cart-main__recs,
     seit 28.07.2026 INNERHALB des Replace-Bereichs) kommt frisch und
     hidden mit aktuellen data-Attributen zurueck und wird neu geladen.
     subtree:true noetig (der Austausch passiert auf .js-contents, nicht
     auf #main-cart-items); eigene Renderings innerhalb von
     .jk-cart-related-upsell werden gefiltert, sonst Endlos-Zyklus. */
  var cartItems = document.getElementById('main-cart-items');
  if (cartItems) {
    var cartPageDebounce;
    new MutationObserver(function (muts) {
      var external = muts.some(function (m) {
        return !(m.target && m.target.closest && m.target.closest('.jk-cart-related-upsell'));
      });
      if (!external) return;
      clearTimeout(cartPageDebounce);
      cartPageDebounce = setTimeout(function () {
        initRecs();       // frischer In-Spalten-Container nach js-contents-Replace
        refreshPageRec(); // Legacy: eigenstaendige Section ausserhalb des Replace-Bereichs
      }, 300);
    }).observe(cartItems, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[href="#cart-drawer"]') || e.target.closest('cart-notification-button')) {
      setTimeout(initRecs, 120);
    }
  });
})();
